import { AnimatePresence } from 'framer-motion';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { AnimatedTab } from '../../components/animation/AnimatedTab';
import { SidebarModal } from '../../components/common/Sidebar/Sidebar';
import {
  BACKOFFICE_NAME,
  BACKOFFICE_NAME_CAPS,
  dateDifferenceInDaysFromToday
} from '../../helpers/helperFunctions';
import { read, store } from '../../helpers/localstorage-helper';
import { TabSelectButton, Tabs } from '../../styles/GlobalComponents';
import Direct from './Direct/Direct';
import Generations from './Generations/Generations';
import { BackofficeNavWrapper } from './MyTeamBackoffice.styles';
import { SearchTeamMemberInput } from './SearchTeamMemberInput';
import { TeamStructure } from './Structure/TeamStructure/TeamStructure';
import { TradingStructure } from './Structure/TradingStructure/TradingStructure';
import Unilevel from './Unilevel/Unilevel';
import Volume from './Volume/Volume';
import { WarningBox } from './common/WarningBox';

const SELECTED_TAB_LC_KEY = 'MY_TEAM_SELECTED_TAB_LC_KEY';

const MyTeamBackoffice = () => {
  const history = useHistory();
  const { t } = useTranslation('myTeam');

  const defaultTab = 'structure';

  const [tab, setTab] = useState(read(SELECTED_TAB_LC_KEY) ?? defaultTab);

  const [isOpen, setIsOpen] = useState(false);

  const selectTab = (tab) => {
    setTab(tab);
    store(SELECTED_TAB_LC_KEY, tab);
  };

  const { user } = useSelector((state) => state.auth.userInfo);

  const licenceIsExpired =
    dateDifferenceInDaysFromToday(user?.currentVirtualOfficeLicence?.dateEnd) ==
    0;

  useEffect(() => {
    if (licenceIsExpired) {
      setIsOpen(true);
    } else setIsOpen(false);

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [user]);

  return (
    <div style={{ maxWidth: 1280, width: '100%' }}>
      <BackofficeNavWrapper>
        <Tabs>
          <TabSelectButton
            selected={tab === 'structure'}
            onClick={() => selectTab('structure')}>
            <div>{t('structure')}</div>
          </TabSelectButton>

          <TabSelectButton
            selected={tab === 'tradingStructure'}
            onClick={() => selectTab('tradingStructure')}>
            <div>{t('trading_structure')}</div>
          </TabSelectButton>

          <TabSelectButton
            selected={tab === 'direct'}
            onClick={() => selectTab('direct')}>
            <div>{t('directs')}</div>
          </TabSelectButton>
          <TabSelectButton
            selected={tab === 'volume'}
            onClick={() => selectTab('volume')}>
            <div>{t('volume')}</div>
          </TabSelectButton>
          <TabSelectButton
            selected={tab === 'generations'}
            onClick={() => selectTab('generations')}>
            <div>{t('generations')}</div>
          </TabSelectButton>
          <TabSelectButton
            selected={tab === 'unilevel'}
            onClick={() => selectTab('unilevel')}>
            <div>{t('unilevel')}</div>
          </TabSelectButton>
        </Tabs>

        {tab === 'structure' && <SearchTeamMemberInput tab={tab} />}
      </BackofficeNavWrapper>

      <AnimatePresence exitBeforeEnter>
        {tab === 'structure' && (
          <AnimatedTab key={'structure'}>
            <TeamStructure tab={tab} />
          </AnimatedTab>
        )}
        {tab === 'tradingStructure' && (
          <AnimatedTab key={'tradingStructure'}>
            <TradingStructure selectTab={selectTab} />
          </AnimatedTab>
        )}
        {tab === 'direct' && (
          <AnimatedTab key={'direct'}>
            <Direct />
          </AnimatedTab>
        )}
        {tab === 'volume' && (
          <AnimatedTab key={'volume'}>
            <Volume tab={tab} />
          </AnimatedTab>
        )}
        {tab === 'generations' && (
          <AnimatedTab key={'generations'}>
            <Generations tab={tab} />
          </AnimatedTab>
        )}
        {tab === 'unilevel' && (
          <AnimatedTab key={'unilevel'}>
            <Unilevel tab={tab} />
          </AnimatedTab>
        )}
      </AnimatePresence>
      <SidebarModal
        isOpen={isOpen}
        setOpen={setIsOpen}
        hasCloseButton={false}
        overlayClose={true}
        title={`${BACKOFFICE_NAME_CAPS}   RENEWAL`}
        sidebarWidth={'511px'}>
        <WarningBox
          text={`YOUR ${BACKOFFICE_NAME_CAPS}  SUBSCRIPTION HAS EXPIRED. RENEW THE SUBSCRIPTION NOW TO ACCESS ALL PERKS AND FEATURES.`}
          virtualOfficeButtonText={`Continue without ${BACKOFFICE_NAME} `}
          buttonText={`Purchase ${BACKOFFICE_NAME}  Subscription`}
          virtualOfficeButtonFn={() => history.push('/backoffice/dashboard')}
          buttonFn={() => history.push('/backoffice/settings/virtual-office')}
        />
      </SidebarModal>
    </div>
  );
};

export default MyTeamBackoffice;
